import _ from 'underscore';
import formatRelativeDatetimes from './formatRelativeDatetimes'

// Ignore mutations if they target only elements of one of these classes
const observerTargetClassBlacklist = [
  "textoverlay",
  "js-localized-datetime"
];

let observer = null;

const isBlacklisted = (mutationList) => {
  const classNames = _.uniq(_.map(mutationList, mutation => mutation.target.className));
  return (classNames.length === 1) && !!observerTargetClassBlacklist.indexOf(classNames[0]);
};

function formatDatetimes(mutationList) {
  if (isBlacklisted(mutationList)) { return; }

  formatRelativeDatetimes();
};

const startObserver = () => {
  const callback = formatDatetimes.bind(this);
  callback();
  observer = new MutationObserver(callback);
  return observer.observe(document.getElementById("page-container"), { childList: true, subtree: true });
};

const setDatetimeObserver = () => {
  if (observer) {
    observer.disconnect();
    observer = null;
  }
  return startObserver();
};

export default setDatetimeObserver;



// WEBPACK FOOTER //
// ./app/javascript/app/utils/datetimeObserver.js